
















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CustomModal extends Vue {
  @Prop() private id!: string;
  @Prop() private title!: string;
  @Prop() customClass!: string;
  @Prop() actionTitle!: string;
  @Prop() action!: Function;
  @Prop() showLoader!: boolean;

  closeModal() {
    this.modal(this.id, false);
  }
}
